import React from "react";
import "./blog.css";
import { Link } from "react-router-dom";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import axios from "axios";
import { useEffect, useState } from "react";

const Blogs = () => {
  const [Blog, setBlog] = useState([]);
  const [blogcategory, setBlogcategory] = useState([]);
   const [recentblog, setRecentblog] = useState([]);
     const [comment, setComment] = useState([]);
   
  const [loading, setLoading] = useState(true);

  const INITIAL_VISIBLE = 5;
  const LOAD_INCREMENT = 4;
   const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);

  const handleLoadMore = () => {
    setLoadMoreLoading(true);
    setTimeout(() => {
      setVisibleCount((prev) => Math.min(prev + LOAD_INCREMENT, Blog.length));
      setLoadMoreLoading(false);
    }, 1000); // simulate 1 second delay
  };

  // BLOGS
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/blogs.php")
      .then((response) => {
        setBlog(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
        setLoading(false);
      });
  }, []);

  // BLOG CATAGORIES
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/blog-category.php")
      .then((response1) => {
        setBlogcategory(response1.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

   // Recent BLOG 
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/otherblog.php?type=latest")
      .then((response2) => {
        setRecentblog(response2.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);


   // Comments
  // Recent BLOG
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/comments.php")
      .then((response3) => {
        setComment(response3.data);
        console.log("Comments Data", response3.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);


  return (
    <div id="rs-latest-news" className="rs-latest-news ">
      {/* <img
          src="assetsfront/images/wvid.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        /> */}
      <div className="container">
        <div className="sec-title mt-4 mb-3 text-center">
          <h2>
            Our: <span className="info-color">Blogs</span>
          </h2>
        </div>

        <div className="blog_container row">
          {/* Left Blog Column */}
          <div className="col-lg-8 col-md-12">
            <div className="row">
              {/* Full Width Blog Card */}

              {Blog && Blog.length > 0 && (
                <div className="blog_card col-12">
                  <div className="figure">
                    <span className="tag">📅{Blog[0].publishdate}</span>
                    <img src={Blog[0].image} alt="Blog" />
                  </div>
                        <Link style={{color:"#ff3115"}}  to={`/blogdetails/${Blog[0].slug}`} className="title1">
                    {Blog[0].blog_title}
                  </Link>
                  <p>
                    {Blog[0].description?.slice(0, 150) ||
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla volutpat est id lorem aliquet, at fermentum elit euismod."}
                  </p>
                  <div className="blog_meta p-3">
                    <span className="text-muted">
                      <i className="fa fa-calendar" /> {Blog[0].readable_date}
                    </span>{" "}
                    &nbsp; &nbsp;
                    <span
                      className="text-muted"
                      style={{ textTransform: "capitalize" }}
                    >
                      <i className="fa fa-tags" /> {Blog[0].blog_cat_name}{" "}
                      &nbsp; &nbsp;
                      <i className="fa fa-eye" /> {Blog[0].blog_views} &nbsp;
                      &nbsp;
                      <i className="fa fa-comments" /> 0
                    </span>
                  </div>
                  <div className="read_more">
                  
                    <Link  to={`/blogdetails/${Blog[0].slug}`}  type="button" className="btn btn-dark px-3">
                      Read More <DoubleArrowIcon className="right-move1" />
                    </Link>
                  
                  </div>
                </div>
              )}

              {/* Half Width Blog Card 1 */}
              {loading ? (
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#002347",
                    fontSize: "30px",
                  }}
                >
                  Please Wait
                  <span className="dot-loader">
                    {[...Array(9)].map((_, i) => (
                      <span className="dot" key={i}></span>
                    ))}
                  </span>
                </span>
              ) : Blog && Blog.length > 0 ? (
                Blog.slice(1, visibleCount).map((blog, index) => (
                  <div className="blog_card col-md-6 col-12" key={index}>
                    <div className="figure">
                      <span className="tag">📅 {blog.publishdate}</span>
                      <img src={blog.image} alt="Blog" />
                    </div>
                    <Link  to={`/blogdetails/${blog.slug}`} 
                      className="title1"
                      style={{color:"#ff3115"}}
                      title={blog.blog_title} // show full title on hover
                    >
                      {blog.blog_title.split(" ").slice(0, 4).join(" ") +
                        (blog.blog_title.split(" ").length > 4 ? "..." : "")}
                    </Link>

                    <div className="blog_meta p-3">
                      <span className="text-muted">
                        <i className="fa fa-calendar" /> {blog.readable_date}
                      </span>{" "}
                      &nbsp; &nbsp;
                      <span
                        className="text-muted"
                        style={{ textTransform: "capitalize" }}
                      >
                        <i className="fa fa-tags" /> {blog.blog_cat_name} &nbsp;
                        &nbsp;
                        <i className="fa fa-eye" /> {blog.blog_views} &nbsp;
                        &nbsp;
                        <i className="fa fa-comments" /> 0
                      </span>
                    </div>
                    <div className="read_more">
                     <Link  to={`/blogdetails/${blog.slug}`} type="button" className="btn btn-dark px-3">
                        Read More <DoubleArrowIcon className="right-move1" />
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>No blogs available</p>
              )}

              {/* Load More Button or Spinner */}
              {Blog && visibleCount < Blog.length && (
                <div className="col-12 text-center mt-3">
                  {loadMoreLoading ? (
                    <svg class="loader" viewBox="0 0 100 100">
                      <circle class="circle" cx="50" cy="50" r="10"></circle>
                      <circle class="circle" cx="50" cy="50" r="20"></circle>
                      <circle class="circle" cx="50" cy="50" r="30"></circle>
                      <circle class="circle" cx="50" cy="50" r="40"></circle>
                    </svg>
                  ) : (
                    // <div className="spinner-border text-primary" role="status">
                    //   <span className="sr-only">Loading...</span>
                    // </div>
                    <button
                      className="btn1"
                      style={{ background: "#007bff", color: "white" }}
                      onClick={handleLoadMore}
                    >
                      Load More
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4 col-md-12 mt-4 mt-lg-0">
            {/* Search Box */}
            <div className="columns">
              <div className="box-search">
                <input
                  className="form-control"
                  placeholder="Search Here ..."
                  name="srch-term"
                  type="text"
                />
              </div>
            </div>

            {/* Recent Posts */}
            <div className="columns">
              <div className="title1">Recent Posts</div>
              <div className="posts">
                {recentblog && recentblog.length > 0 ? (
                  recentblog.map((recent, index3) => (
                <Link  to={`/blogdetails/${recent.slug}`} key={index3}>
                  <img
                    src={recent.image}
                    alt=""
                  />
                  <p>{recent.blog_title}</p>
                </Link>
                     ))
                ) : (
                  <p>Loading categories...</p>
                )}
              </div>
            </div>

            {/* New Books */}
            {/* <div className="columns">
              <div className="title">New Books</div>
              <div className="cards">
                <img
                  src="https://viasacademy.com/vias_admin/upload_books/6f9f0c876141e86dce60e213a2606c0a.png"
                  className="card_part"
                />
                <img
                  src="https://viasacademy.com/vias_admin/upload_books/b4d3f3c706f5761f383eeade86fecf39.PNG"
                  className="card_part"
                />
              </div>
            </div> */}

            {/* Categories */}

            <div className="columns">
              <div className="title1">Categories</div>
              <div className="categories">
                {blogcategory && blogcategory.length > 0 ? (
                  blogcategory.map((cate, index2) => (
                    <a
                      key={index2}
                      href="#"
                      className="btn1"
                      style={{
                        display: "inline-block",
                        margin: 2,
                        padding: "5px 10px",
                        fontSize: 12,
                      }}
                    >
                      {cate.category_name}
                    </a>
                  ))
                ) : (
                  <p>Loading categories...</p>
                )}
              </div>
            </div>

            {/* Comments */}

            <div className="columns comments">
              <span className="title1">Recent Comments</span>

              {/* scrolling area */}
              <div
                className="marquee-box"
                onMouseOver={(e) => e.currentTarget.classList.add("paused")}
                onMouseOut={(e) => e.currentTarget.classList.remove("paused")}
              >
                 <div className="marquee-track">
                    {comment && comment.length > 0 ? (
                      comment.map((data, index3) => (
                  <div className="dsc-comments">
                                <a href="#"> {data.name}</a>
                                <p>{data.comments}</p>  
                              </div>
                    ))
                    ) : (
                      <p>Loading Comments...</p>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
